import React, {Component} from "react";
import {Button, Col, Form, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader} from "reactstrap";
import {AuthPageType} from "../../helper/enums";
import {deepCopyObject, showAxiosError} from "../../helper/helper";
import {isValidDbsAuth, isValidTurmobAuth, isValidUtsAuth} from "../../common/componentValidation";
import {request} from "../../helper/APIUtils";
import Alert from "react-s-alert";

class IvdModal extends Component{
    constructor(props) {
        super(props);
        this.state = {
            data: {},
        }
        this.onChangeData = this.onChangeData.bind(this);
    }

    onChangeData = (name, value) => {
        let data = deepCopyObject(this.state.data);
        data[name] = value;
        this.setState({data: data});
    }

    save = () => {
        let self = this;
        let data = deepCopyObject(self.state.data);
        let result = isValidDbsAuth(data, AuthPageType.INTERAKTIFVD)

        if (result.valid) {
            let params = {
                url: "/ivd/auth/saveIvdAuth",
                method: "post",
                data: data
            };
            request(params)
                .then(function (response) {
                    if (response.data) {
                        Alert.success("Kaydetme işlemi başarılı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({data: response.data});
                        self.props.toggle()
                    }
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    test = () => {
        let self = this;
        let data = deepCopyObject(self.state.data);
        let result = isValidDbsAuth(data, AuthPageType.INTERAKTIFVD)

        if (result.valid) {
            let params = {
                url: "/ivd/auth/testConnection",
                method: "post",
                data: data
            };
            request(params)
                .then(function (response) {
                    if (response.data) {
                        Alert.success("Başarıyla giriş yapıldı.", {
                            position: 'top-right',
                            effect: 'stackslide',
                            timeout: 2000
                        });
                        self.setState({data: response.data});
                    }
                }).catch(function (error) {
                showAxiosError(error);
            });
        } else {
            Alert.error(result.errorMessage, {
                position: 'top-right',
                effect: 'stackslide',
                timeout: 2000
            });
        }
    }

    render() {
        return (
            <Modal  isOpen={this.props.isOpen} size="md">
                <ModalHeader
                    className="justify-content-center">
                    İnteraktif Vergi Dairesi Bilgileri
                </ModalHeader>
                <ModalBody>
                    <div>
                        <FormGroup row style={{textAlign: 'center'}}>
                            <Label sm={12} for="formattedName" style={{fontWeight: 'bold', fontSize: '16px'}}>Lütfen eksik İnteraktif Vergi Dairesi
                                bilgilerinizi doldurunuz.</Label>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="username">Kullanıcı Adı: *</Label>
                            <Col sm={8}>
                                <input className="form-control"
                                       type="text"
                                       name="username"
                                       autoComplete={"false"}
                                       value={this.state.data && this.state.data.username ? this.state.data.username : ''}
                                       onChange={(e) => this.onChangeData("username", e.target.value)}/>
                            </Col>
                        </FormGroup>
                        <FormGroup row>
                            <Label sm={4} for="password">Şifre: *</Label>
                            <Col sm={8}>
                                <input className="form-control"
                                       type="password"
                                       name="password"
                                       autoComplete={"false"}
                                       value={this.state.data && this.state.data.password ? this.state.data.password : ''}
                                       onChange={(e) => this.onChangeData("password", e.target.value)}/>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                        </FormGroup>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="secondary" onClick={()=>this.props.toggle(false)}>
                        Kapat
                    </Button>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="info" onClick={()=>this.test()}>
                        Test Et
                    </Button>
                    <Button style={{paddingLeft: '16px', width: '100px'}} color="success" onClick={() => this.save()}>
                        Kaydet
                    </Button>
                </ModalFooter>
            </Modal>
        )
    }
}
export default IvdModal